import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

import LoginView from '../views/LoginView.vue'
import MembersView from '../views/MembersView.vue'
import AddMembersView from '../views/AddMembersView.vue'
import EventView from '../views/EventView.vue'
import BroadcastView from '../views/BroadcastView.vue'
import SpeakersView from '../views/SpeakersView.vue'
import ScheduleView from '../views/ScheduleView.vue'
import SwitchView from '../views/SwitchView.vue'
import VenueView from '@/views/VenueView.vue'
import TestView from '../views/TestView.vue'



const routes = [
	{
		path: '/',
		name: 'login',
		component: LoginView,
		meta:{
			title:'Community platform -  Login',
			auth:false
		}
	},
	{
		path: '/members',
		name: 'members',
		component: MembersView,
		meta:{
			title:'Community platform -  Member',
			auth:true
		}
	},
	{
		path: '/add-members',
		name: 'add-members',
		component:AddMembersView,
		meta:{
			title:'Community platform -  Add Member',
			auth:true
		}
	},
	{
		path: '/event',
		name: 'event',
		component:EventView,
		meta:{
			title:'Community platform -  Event',
			auth:true
		}
	},
	{
		path: '/broadcast',
		name: 'broadcast',
		component:BroadcastView,
		meta:{
			title:'Community platform -  Broadcast',
			auth:true
		}
	},
	{
		path: '/test',
		name: 'test',
		component:TestView,
		meta:{
			title:'Community platform -  test',
			auth:true
		}
	},
	{
		path: '/speakers',
		name: 'speakers',
		component:SpeakersView,
		meta:{
			title:'Community platform -  Speaker',
			auth:true
		}
	},
	{
		path: '/schedule',
		name: 'schedule',
		component:ScheduleView,
		meta:{
			title:'Community platform -  Schedule',
			auth:true
		}
	},
	{
		path: '/switch',
		name: 'switch',
		component:SwitchView,
		meta:{
			title:'Community platform -  Event',
			auth:true
		}
	},
	{
		path: '/venue',
		name: 'venue',
		component:VenueView,
		meta:{
			title:'Community platform -  Venue',
			auth:true
		}
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})


router.beforeEach((to, from, next)=>{
	console.log('to',to);
	console.log('from',from);
	//    console.log('next',next());
	
	if('auth' in to.meta && to.meta.auth && !store.state.authentication.token){
		document.title = `${to.meta.title}`;
		next('/');
	}else if('auth' in to.meta && !to.meta.auth && store.state.authentication.token){
		document.title = `${to.meta.title}`;
		next('/members');
	}else{
		document.title = `${to.meta.title}`;
		next();
	}
})

export default router
